import { potentialBiddersService } from '@/services/potential-bidders.service';
import axios from 'axios';

const initialState = () => ({
  potentialBidders: [],
  status: {
    error: null,
    pending: true,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  getPotentialBidders({ commit }, opportunityId) {
    commit('GET_POTENTIAL_BIDDERS');
    return potentialBiddersService.getPotentialBidders(opportunityId).then(
      (potentialBidders) => {
        commit('SUCCESS_GETTING_POTENTIAL_BIDDERS', potentialBidders);
      },
      (error) => {
        if (!axios.isCancel(error)) {
          commit('ERROR', error);
          throw error;
        }
      },
    );
  },

  createPotentialBidder({ commit }, { opportunityId, potentialBidderData }) {
    commit('CRUD_POTENTIAL_BIDDERS');
    return potentialBiddersService.createPotentialBidder(opportunityId, potentialBidderData).then(
      (potentialBidder) => {
        commit('SUCCESS_CREATING_POTENTIAL_BIDDER', potentialBidder);
      },
      (error) => {
        if (!axios.isCancel(error)) {
          commit('ERROR', error);
          throw error;
        }
      },
    );
  },

  editPotentialBidder({ commit }, { opportunityId, potentialBidderId, potentialBidderData }) {
    commit('CRUD_POTENTIAL_BIDDERS');
    return potentialBiddersService.editPotentialBidder(opportunityId, potentialBidderId, potentialBidderData).then(
      (potentialBidder) => {
        commit('SUCCESS_EDITING_POTENTIAL_BIDDER', potentialBidder);
      },
      (error) => {
        if (!axios.isCancel(error)) {
          commit('ERROR', error);
          throw error;
        }
      },
    );
  },

  deletePotentialBidder({ commit }, { opportunityId, potentialBidderId }) {
    commit('CRUD_POTENTIAL_BIDDERS');
    return potentialBiddersService.deletePotentialBidder(opportunityId, potentialBidderId).then(
      () => {
        commit('SUCCESS_DELETING_POTENTIAL_BIDDER', potentialBidderId);
      },
      (error) => {
        if (!axios.isCancel(error)) {
          commit('ERROR', error);
          throw error;
        }
      },
    );
  },
};

const mutations = {
  GET_POTENTIAL_BIDDERS(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
    state.potentialBidders = [];
  },
  CRUD_POTENTIAL_BIDDERS(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  SUCCESS_GETTING_POTENTIAL_BIDDERS(state, potentialBidders) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.potentialBidders = potentialBidders;
  },
  SUCCESS_CREATING_POTENTIAL_BIDDER(state, potentialBidder) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    if (state.potentialBidders && state.potentialBidders.length > 0) {
      state.potentialBidders.push(potentialBidder);
    } else {
      state.potentialBidders = [potentialBidder];
    }
  },
  SUCCESS_EDITING_POTENTIAL_BIDDER(state, editedPotentialBidder) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    if (state.potentialBidders && state.potentialBidders.length > 0) {
      state.potentialBidders = state.potentialBidders.map((potentialBidder) => {
        if (potentialBidder.id === editedPotentialBidder.id) {
          return editedPotentialBidder;
        }
        return potentialBidder;
      });
    }
  },
  SUCCESS_DELETING_POTENTIAL_BIDDER(state, deletedPotentialBidderId) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    if (state.potentialBidders && state.potentialBidders.length > 0) {
      state.potentialBidders = state.potentialBidders.filter(
        (potentialBidder) => potentialBidder.id !== deletedPotentialBidderId,
      );
    }
  },
  ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error: error,
    };
  },
  RESET(state) {
    const initial = initialState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
};

const getters = {
  potentialBidders: (state) => state.potentialBidders,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const potentialBidders = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
